export const SystemActionTypes = {
  SYSTEM_INIT: 'system/init',
  SYSTEM_RESET: 'system/reset',
}
